import React, { useId } from 'react';

const Icon = ({ width = '57', height = '45', fill = '#FFEFBC', ...other }) => {
    const id = useId();
    const gradientA = `kingIcon-gradient-a-${id}`;
    const gradientB = `kingIcon-gradient-b-${id}`;
    const gradientC = `kingIcon-gradient-c-${id}`;

    return (
        <svg width={width} height={height} viewBox="0 0 57 45" fill="none" {...other}>
            <path
                d="m7.898 43.115-2.641-22.89c-.1-.859.865-1.43 1.571-.93L17 26.5l11.158-16.271a1 1 0 0 1 1.66.016L40.5 26.5l9.648-7.131c.704-.52 1.688.05 1.588.919l-2.634 22.827a1 1 0 0 1-.993.885H8.89a1 1 0 0 1-.993-.885Z"
                fill={fill}
            />

            <path
                d="m17 26.5 11.41 8.082a1 1 0 0 0 1.172-.012L40.5 26.5m-23.5 0L6.828 19.295c-.706-.5-1.67.071-1.571.93l2.64 22.89a1 1 0 0 0 .994.885H48.11a1 1 0 0 0 .993-.885l2.634-22.828c.1-.868-.884-1.438-1.588-.918L40.5 26.5m-23.5 0 11.158-16.271a1 1 0 0 1 1.66.016L40.5 26.5"
                stroke={`url(#${gradientA})`}
                strokeWidth="2"
                strokeLinecap="round"
            />

            <circle cx="5" cy="15" r="4" stroke={`url(#${gradientB})`} strokeWidth="2" />

            <circle cx="29" cy="5" r="4" stroke="#F1CC8A" strokeWidth="2" />

            <circle cx="52" cy="15" r="4" stroke={`url(#${gradientC})`} strokeWidth="2" />

            <defs>
                <linearGradient id={gradientA} x1="28.5" y1="9" x2="28.5" y2="44" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CA88" />

                    <stop offset="1" stopColor="#C7914F" />
                </linearGradient>
                <linearGradient id={gradientB} x1="5" y1="10" x2="5" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC8A" />

                    <stop offset="1" stopColor="#E3B775" />
                </linearGradient>
                <linearGradient id={gradientC} x1="52" y1="10" x2="52" y2="20" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F1CC8A" />

                    <stop offset="1" stopColor="#E4B976" />
                </linearGradient>
            </defs>
        </svg>
    );
};
export default React.memo(Icon);
